import React from 'react';

export default function FormSkeleton() {
  return (
    <div className="wizard-container">
      <div style={{ marginBottom: 30 }}>
        <div style={{ ...skeleton.line, width: 70, height: 12, marginBottom: 8 }} />
        <div style={{ ...skeleton.line, height: 4, borderRadius: 2 }} />
      </div>

      <div style={{ ...skeleton.line, width: '40%', height: 26, marginBottom: 25 }} />

      {[0, 1, 2].map(row => (
        <div key={row} style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          <div style={{ flex: 1 }}>
            <div style={{ ...skeleton.line, width: '35%', height: 12, marginBottom: 8 }} />
            <div style={{ ...skeleton.line, height: 42 }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ ...skeleton.line, width: '35%', height: 12, marginBottom: 8 }} />
            <div style={{ ...skeleton.line, height: 42 }} />
          </div>
        </div>
      ))}

      <div style={{ marginBottom: 20 }}>
        <div style={{ ...skeleton.line, width: '25%', height: 12, marginBottom: 8 }} />
        <div style={{ ...skeleton.line, height: 60 }} />
      </div>

      <div style={{ marginBottom: 30 }}>
        <div style={{ ...skeleton.line, width: '30%', height: 12, marginBottom: 8 }} />
        <div style={{ ...skeleton.line, height: 48 }} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ ...skeleton.line, width: 100, height: 40 }} />
        <div style={{ ...skeleton.line, width: 100, height: 40 }} />
      </div>

      <style>{`
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }
      `}</style>
    </div>
  );
}

const skeleton = {
  line: {
    background: 'linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%)',
    backgroundSize: '600px 100%',
    animation: 'shimmer 1.6s ease-in-out infinite',
    borderRadius: 6,
  },
};
